/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { UserRole } from '@shared/models/user-role';

export enum Permission {
  WriteDrivers = 'WRITE_DRIVERS',
  WriteAbsences = 'WRITE_ABSENCES',
  WriteOwnProfile = 'WRITE_OWN_PROFILE',
}

const ROLES_PER_PERMISSION: Record<Permission, UserRole[]> = {
  [Permission.WriteDrivers]: [UserRole.User, UserRole.Personnel],
  [Permission.WriteAbsences]: [UserRole.User, UserRole.Personnel],
  [Permission.WriteOwnProfile]: [UserRole.User, UserRole.Personnel],
};

/**
 * ngx-permissions kennt keine Rollenhierarchie und prueft nur auf Namensgleichheit.
 * Die Rollen bleiben deshalb erhalten - die abgeleiteten Berechtigungen kommen
 * zusaetzlich dazu.
 */
export function withDerivedPermissions(roles: string[]): string[] {
  const permissions = Object.values(Permission).filter(
    permission => ROLES_PER_PERMISSION[permission].some(role => roles.includes(role))
  );

  return [...roles, ...permissions];
}
